import type Pusher from 'pusher-js';

import { storeToRefs } from 'pinia';

import type { PusherConfig } from '~/types/websocket';

import { usePusherConnectionStore } from '~/stores/pusherConnection';

export type { PusherConfig };

export const usePusherConnection = () => {
  // Return null on server (SSR safety)
  if (import.meta.server) {
    return null;
  }

  const store = usePusherConnectionStore();
  const { pusherClient, connectionState, isConnected, activeSubscriptions } = storeToRefs(store);

  const initialize = (config: PusherConfig): Promise<Pusher> => {
    return store.initialize(config);
  };

  const onReconnected = (callback: () => void | Promise<void>): (() => void) => {
    return store.addReconnectCallback(callback);
  };

  return {
    pusher: pusherClient,
    connectionState,
    isConnected,
    activeSubscriptions,
    initialize,
    onReconnected,
  };
};
